<div class="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
  <div class="flex flex-col text-darkGray">
    <span class="text-[16px] font-semibold">QRIS History</span>
    <span class="text-[12px] text-[#667085]"
      ><span class="font-medium text-primary">{{
        pagination.total_count || 0
      }}</span>
      Total generation</span
    >
  </div>

  <div
    class="border rounded py-0 px-1 flex flex-row w-full md:w-1/4 h-10 overflow-hidden"
  >
    <input
      type="text"
      class="btn p-0 date-pick w-full md:w-[617px]"
      ngxDaterangepickerMd
      [(ngModel)]="selected"
      [ngModelOptions]="{ standalone: true }"
      [showCustomRangeLabel]="true"
      [keepCalendarOpeningWithRange]="true"
      [alwaysShowCalendars]="true"
      [ranges]="ranges"
      [linkedCalendars]="true"
      [isInvalidDate]="isInvalidDate"
      [showCancel]="true"
      [showRangeLabelOnInput]="true"
      opens="left"
      drops="down"
      [locale]="setlocale"
      (datesUpdated)="onChangeDate($event)"
      style="border: none; font-size: 14px; overflow: auto !important"
      #datePickerInput
    />
    <div
      class="p-2 flex items-center justify-center ngx-daterangepicker-action"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg"
        alt="calendar"
        width="40"
        height="40"
      />
    </div>
  </div>
</div>

<nz-table
  class="mt-3"
  #table
  [nzData]="listOfData"
  [nzLoading]="loading"
  [nzShowPagination]="false"
  [nzFrontPagination]="false"
  [nzScroll]="{ x: '1000px' }"
>
  <thead>
    <tr>
      <th nzWidth="150px">QRIS ID</th>
      <th nzWidth="120px">Amount</th>
      <th nzWidth="150px">Payment Status</th>
      <th nzWidth="180px">Created At</th>
      <th nzWidth="180px">Updated At</th>
      <th nzWidth="250px">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of table.data">
      <td>{{ data.qris_id }}</td>
      <td>
        <span class="font-medium text-green-500">{{
          data.final_amount | currency : "Rp" : "symbol" : "1.0-0"
        }}</span>
      </td>
      <td>
        <span
          class="p-2 rounded-pill text-center w-[100px] flex items-center justify-center font-medium capitalize"
          [class]="getClassStatus(data.payment_status)"
        >
          {{ data.payment_status }}
        </span>
      </td>
      <td>{{ data.created_at | date : "dd MMMM yyyy HH:mm" }}</td>
      <td>{{ data.updated_at | date : "dd MMMM yyyy HH:mm" }}</td>
      <td>
        <div class="flex items-center gap-2">
          <button
            *ngIf="data.payment_status === 'unpaid'"
            nz-button
            nzSize="large"
            class="bg-[#08A0F7] text-white flex items-center gap-1 w-[120px]"
            (click)="showConfirmPayment(data)"
          >
            <div class="flex items-center gap-1">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/tick-circle.svg"
                alt="download"
                width="16"
                height="16"
              />
              <span class="text-[10px] whitespace-nowrap">Mark as Paid</span>
            </div>
          </button>
          <div
            *ngIf="data.payment_status === 'unpaid'"
            class="h-5 bg-gray-300 w-0.5"
          ></div>
          <a
            nz-button
            nzType="link"
            class="text-[#08A0F7]"
            (click)="viewDetail(data)"
            >View</a
          >
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
<app-pagination
  [currentPage]="pagination.current_page"
  [totalItems]="pagination.total_count"
  [perPage]="filterList.limit"
  [disablePrev]="isDisPrev"
  [disableNext]="isDisNext"
  [perPageOptions]="[20, 40, 60, 80, 100]"
  (pageChange)="onPageChange($event)"
  (perPageChange)="onPerPageChange($event)"
  (itemsPerPageChange)="getListPage($event)"
>
</app-pagination>

<app-modal-confirm-payment
  [isVisible]="isVisibleConfirmPayment"
  (cancel)="isVisibleConfirmPayment = false"
  (confirm)="markAsPaid()"
></app-modal-confirm-payment>
